/* File: themeToggle.jsx
 * Path: ananunadm/src/components/main/theme-toggle/themeToggle.jsx
*/
import cx from "clsx";
import { ActionIcon, useMantineColorScheme, Group, Button } from "@mantine/core";
import { IconSun, IconMoon } from "@tabler/icons-react";
import classes from "@/theme/ThemeToggle.module.css";

export function ThemeToggle({ isMobile }) {
	const { colorScheme, toggleColorScheme } = useMantineColorScheme();
	const iconSize = isMobile ? 16 : 22;

	return (
		<Group position="center">
			<Button
				onClick={() => toggleColorScheme()}
				variant="subtle"
				aria-label="Toggle color scheme"
				size={isMobile ? "sm" : "md"}
				style={{
					margin: 0,
					padding: isMobile ? 4 : 10,
					minWidth: isMobile ? 30 : undefined,
					width: isMobile ? 30 : undefined,
					height: isMobile ? 30 : undefined
				}}
			>
				{colorScheme === "dark" && (
					<IconSun
						className={cx(classes.icon, classes.light)}
						size={iconSize}
						stroke={1.5}
						style={{ width: iconSize, height: iconSize }}
					/>
				)}
				{colorScheme === "light" && (
					<IconMoon
						className={cx(classes.icon, classes.dark)}
						size={iconSize}
						stroke={1.5}
						style={{ width: iconSize, height: iconSize }}
					/>
				)}
			</Button>
		</Group>
	);
}
